import { useRef } from 'react'

/**
 * Hook to prevent unnecessary object recreations by deep comparing values
 * Returns the same reference if the value hasn't actually changed (deep equal)
 */
export const useStableValue = <T,>(value: T): T => {
  const prevValue = useRef<T>(value)

  // Deep comparison to check if value actually changed
  const hasChanged = JSON.stringify(prevValue.current) !== JSON.stringify(value)

  if (hasChanged) {
    prevValue.current = value
  }

  return prevValue.current
}

